export function updateStatus(state: any, action: any): any {
  let allStatusActive: boolean = true;
  let lastStatusActive: boolean = true;

  for (const status of state) {
    if (!status.show) {
      allStatusActive = false;
    }
    if (status.show && status.marker !== action.payload.marker) {
      lastStatusActive = false;
    }
  }
  if (allStatusActive) {
    return state.map((item) =>
      item.marker === action.payload.marker ? item : { ...item, show: false }
    );
  } else if (lastStatusActive) {
    return state.map((item) => {
      return { ...item, show: true };
    });
  } else {
    const updatedPayload = { ...action.payload, show: !action.payload.show };
    return state.map((item) =>
      item.marker === action.payload.marker
        ? Object.assign({}, item, updatedPayload)
        : item
    );
  }
}

export function updateStatusDetail(state: any, action: any): any {
  let allStatusActive: boolean = true;
  let lastStatusActive: boolean = true;

  for (const status of state) {
    if (!status.showDetail) {
      allStatusActive = false;
    }
    if (status.showDetail && status.marker !== action.payload.marker) {
      lastStatusActive = false;
    }
  }
  if (allStatusActive) {
    return state.map((item) =>
      item.marker === action.payload.marker
        ? item
        : { ...item, showDetail: false }
    );
  } else if (lastStatusActive) {
    return state.map((item) => {
      return { ...item, showDetail: true };
    });
  } else {
    const updatedPayload = {
      ...action.payload,
      showDetail: !action.payload.showDetail
    };
    return state.map((item) =>
      item.marker === action.payload.marker
        ? Object.assign({}, item, updatedPayload)
        : item
    );
  }
}
